import styled from 'styled-components';

import { media } from '@theme/media';
import { OFFSET } from '@theme/helpers';

export const Container = styled.div<{ isVisible: boolean }>`
  margin: ${OFFSET.L} 0;
  position: relative;
  width: 100%;
  text-align: center;
  padding: 0 ${OFFSET.XS} ${OFFSET.XS};
  transition: opacity 0.2s ease-in-out;
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};

  ${media.tablet} {
    padding: 0 ${OFFSET.M} ${OFFSET.L};
  }
`;
